<div class="ir-modal--title">
  <div class="ir-line--right" *ngIf="showMenuButton()">
    <div class="ir-btn th-btn-modal" (click)="openMenu()">
      <i class="material-icons">more_vert</i>
    </div>
  </div>
  <div class="ir-line--right" *ngIf="enableSearch && !showSearch">
    <div class="ir-btn th-btn-modal" (click)="updateShowSearch(true)">
      <i class="material-icons">search</i>
    </div>
  </div>
  <div class="ir-line--right">
    <div class="ir-btn th-btn-icon" style="background-color: transparent">
      <ng-container *ngFor="let session of plugin?.sessionIcons">
        <i
          *ngIf="session.user"
          (click)="navigateToSession(session)"
          [title]="session.user"
          class="material-icons session"
          [style.color]="session.color"
          [class.disabled]="session.away"
          style="margin-left: 0.2em"
          [class.away]="session.away"
          [class.active]="!session.away"
          [class.highlight]="session.highlight && !session.away"
          >account_circle</i
        >
      </ng-container>
      >
    </div>
  </div>
  <div class="ir-line" *ngIf="!showSearch">
    <div class="ir-line-content">
      <span>
        {{ (isEditPage ? 'common.edit' : 'common.add') | translate }} :
        {{ plugin?.point ? plugin?.point?.name : plugin?.inspection?.name }} : &laquo;
        {{ 'plugins.' + (pluginType || plugin?.pluginType) + '.name' | translate }} &raquo;
      </span>
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="queryString"
        focus="showSearch"
      />
    </div>
  </div>
</div>
